<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Tdg - {{this.subTitle}}</h2>
			</b-col>
			<b-col lg="6">			
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editTdg()">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteTdg()">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
						<b-row>
							<b-col md="8">

								<b-form-group :label-cols="4" id="L1" label="Common Name" label-for="Tdg1" horizontal>
									<b-form-input class="plaintext-input" v-if="!edit" plaintext id="Tdg1" v-model="model.common_name" type="text"></b-form-input>
									<b-form-input v-else id="Tdg1" v-model="model.common_name" type="text"></b-form-input>
								</b-form-group>

                                <b-form-group :label-cols="4" id="L2" label="Product Description" label-for="Tdg2" horizontal>
                                    <b-form-input id="Tdg2" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.product_description"></b-form-input>
                                    <b-form-input id="Tdg2" v-else type="text" v-model="model.product_description"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L3" label="Packing Group" label-for="Tdg3" horizontal>
                                    <b-form-input id="Tdg3" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.packing_group"></b-form-input>
                                     <b-form-input id="Tdg3" v-else type="text" v-model="model.packing_group"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L4" label="Class" label-for="Tdg4" horizontal>
                                    <b-form-input id="Tdg4" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.class_tdg"></b-form-input>
                                    <b-form-input id="Tdg4" v-else type="text" placeholder="only numbers" v-mask="'##########'" v-model="model.class_tdg"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L5" label="Shipping Name" label-for="Tdg5" horizontal>
                                    <b-form-input id="Tdg5" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.shipping_name"></b-form-input>
                                    <b-form-input id="Tdg5" v-else type="text" v-model="model.shipping_name"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L6" label="Un" label-for="Tdg6" horizontal>
                                    <b-form-input id="Tdg6" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.un"></b-form-input>
                                    <b-form-input id="Tdg6" v-else type="text" placeholder="only numbers" v-mask="'##########'" v-model="model.un"></b-form-input>
                                </b-form-group> 
                                <div v-if="edit">
                                    <b-form-group v-if="fluidtypeselect.length > 0" :label-cols="4" id="L7" label="Fluid Types" label-for="Tdg7" horizontal>
                                        <b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="fluidtypeselect" name="Checkboxes2" plain v-model="model.fluid_types_id" @input="fluidtypesChange()"></b-form-checkbox-group>
                                        <b-form-checkbox style="margin-top: 15px;" v-model="ftAllSelected" :indeterminate="indeterminateFT" aria-describedby="" aria-controls="" plain @change="FTToggleAll">
                                            {{ ftAllSelected ? 'Un-select All' : 'Select All' }}
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <p v-else>No fluid type registered</p>
                                </div>
                                <div v-else>
                                    <b-form-group v-if="fluidtypeselect.length > 0" :label-cols="4" id="L7" label="Fluid Types" label-for="Tdg7" horizontal>
                                        <b-form-checkbox-group disabled value-field="id" text-field="name"  class="custom-checkboxes" :options="fluidtypeselect" name="Checkboxes2" plain v-model="model.fluid_types_id" ></b-form-checkbox-group>
                                    </b-form-group>
                                    <p v-else>No fluid type registered</p>
                                </div>

								<div slot="footer" v-show="edit">
									<b-button @click="update()" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
									<b-button @click="editTdg()" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
								</div>
							</b-col>
						</b-row>
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	import cnr_service from './cnr_service'
	export default {
		name: 'TdgD',
		created: function() {
			this.getCompanyData()
		},
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		data() {
			return {
				subTitle        : '',
				edit            : false,
				found           : false,
				notFoundMessage : 'Not found',
                model       : {
                        common_name         : '',
                        product_description : '',
                        packing_group       : '',
                        class_tdg           : null,
                        shipping_name       : '',
                        un                  : null,
                        fluid_types_id      : [],
                    },
				updateData      : null,
				originalData    : null,

				loadingData     : true,
                fluidtypeselect				: [],
		        indeterminateFT				: false,
		        ftAllSelected				: false,
			}
		},
		methods: {
			editTdg() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
				}
				this.model = model
			},
			getCompanyData() {
				cnr_service.getBy_tdg(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.originalData   = data.tdg
                            this.fluidtypeselect  = data.fluid_types					
							this.companyId      = this.id
							this.loadingData    = false
							this.found          = true
							this.restoreOriginalData()							
							this.subTitle       = this.companyId
						}else {
                            this.$swal(data.status, data.message, data.status)
                            this.loadingData = false
                            return

                        }
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
                if (this.model.common_name === undefined || this.model.common_name.trim().length == 0) {
                    this.$swal('Alert!', 'Common Name can not be empty', 'warning')
                    return false
                }
                if (this.model.product_description === undefined || this.model.product_description.trim().length == 0) {
                    this.$swal('Alert!', 'Product Description can not be empty', 'warning')
                    return false
                }
                if (this.model.packing_group === undefined || this.model.packing_group.trim().length == 0) {
                    this.$swal('Alert!', 'Packing Group can not be empty', 'warning')
                    return false
                }
                if (this.model.class_tdg === null || this.model.class_tdg.trim().length == 0) {
                    this.$swal('Alert!', 'Class can not be empty', 'warning')
                    return false
                }
                if (this.model.shipping_name  === undefined || this.model.shipping_name.trim().length == 0) {
                    this.$swal('Alert!', 'Shipping Name can not be empty', 'warning')
                    return false
                }
                if (this.model.un === null || this.model.un.trim().length == 0) {
                    this.$swal('Alert!', 'Un can not be empty', 'warning')
                    return false
                }
				return true
			},
            update () {
                if (!this.okToUpdate()) {
					return
				}
                console.log(this.model)
				cnr_service.update_tdg(this.companyId, this.model)
					.then((data) => {
						this.$swal(data.status, data.message, data.status)
							.then((result) => {
								this.getCompanyData()
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			deleteTdg() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Tdg: " + this.model.common_name + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						cnr_service.delete_tdg(this.companyId)
							.then(data => {
								this.$swal(data.status, data.message, data.status)
								if (data.status == 'success') {
									this.$router.replace('/tdgs')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
            FTToggleAll(checked) {
            this.model.fluid_types_id = checked ? this.fluidtypeselect.map(item => {
                return item.id
            }) : []
            },
            fluidtypesChange() {
                if (this.model.fluid_types_id.length === 0) {
                    this.indeterminateFT = false
                    this.ftAllSelected = false
                } else if (this.model.fluid_types_id.length === this.fluidtypeselect.length) {
                    this.indeterminateFT = false
                    this.ftAllSelected = true
                } else {
                    this.indeterminateFT = true
                    this.ftAllSelected = false
                }
            },
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/cnr/tdg.vue